import { LoadState } from "../../constants/enums";
import {
  IActionItemDynamicForm,
  IActionItemDynamicForms,
} from "./actionItemDynamicForm.types";

export const initialActionItemDynamicForms: IActionItemDynamicForms = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
};

export const initialActionItemDynamicForm: IActionItemDynamicForm = {
  action_item_dynamic_form_uuid: null,
  base_version_id: null,
  action_item_category_uuid: null,
  category_code: "",
  category_name: "",
  form_name: "",
  description: "",
  fields: [],
  company_outlet_uuid: null,
  status: "ACTIVE",
};
